import React, { useState } from "react";
import { FaTools, FaCalendarAlt, FaDollarSign, FaArrowRight } from "react-icons/fa";
import Lottie from "lottie-react";
import Fan from "../Animation/fan.json";
import { HiX } from "react-icons/hi";
import GetInTouch from "./GetInTouch";

const WhyChooseUs = () => {
    const [showModal, setShowModal] = useState(false); 
    const openModal = () => {
      setShowModal(true);
    };
  
    const closeModal = () => {
      setShowModal(false);
    };
    return (
        <div>
            <section className="py-12 sm:py-16 bg-white shadow-md relative overflow-hidden mt-10 sm:mt-12 rounded-lg w-[95%] sm:w-[90%] mx-auto">
                {/* Background image on right side (desktop) */}
                <div className="hidden lg:block absolute right-0 top-0 h-full w-1/2">
                    <img
                        src="/why_chose_us_img_2.webp"
                        alt="Air Comfort Experts"
                        className="w-full h-full object-cover object-center"
                    />
                    {/* Centered circle with content */}
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center bg-blue-900 rounded-full w-24 h-24 text-white ring-2 ring-orange-600">
                        <span className="text-2xl font-bold">80%</span>
                        <span className="text-xs text-center">Success Rate</span>
                    </div>
                </div>

                <div className="relative z-10 px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col lg:flex-row">
                        {/* Left side - Content */}
                        <div className="lg:w-1/2 lg:pr-10">
                            <div className="max-w-lg">
                                <div className="flex items-center gap-2 mb-4">
                                    <Lottie className="w-6 sm:w-8" animationData={Fan} />
                                    <h1 className="text-xl sm:text-2xl text-orange-500 font-bold uppercase">Why Choose Us</h1>
                                </div>
                                <p className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">
                                    Your Trusted Air Comfort Experts
                                </p>
                                <p className="text-gray-600 mb-6 sm:mb-8 text-sm sm:text-base">
                                    Air conditioning system is best for your home. Our FrostFree
                                    Consulta-service provides expert guidance.
                                </p>

                                <div className="space-y-5 sm:space-y-6">
                                    {/* Feature 1 */}
                                    <div className="flex items-start">
                                        <div className="mr-4 text-orange-600 mt-1">
                                            <FaTools className="w-6 h-6 sm:w-7 sm:h-7" />
                                        </div>
                                        <div>
                                            <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-1">
                                                Expert Technicians
                                            </h3>
                                            <p className="text-gray-600 text-sm sm:text-base">
                                                Our Quick Cool Installation service provides fast and
                                                efficient installation.
                                            </p>
                                        </div>
                                    </div>

                                    {/* Feature 2 */}
                                    <div className="flex items-start">
                                        <div className="mr-4 text-orange-600 mt-1">
                                            <FaCalendarAlt className="w-6 h-6 sm:w-7 sm:h-7" />
                                        </div>
                                        <div>
                                            <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-1">
                                                Flexible Scheduling
                                            </h3>
                                            <p className="text-gray-600 text-sm sm:text-base">
                                                We work around your schedule to provide convenient service
                                                times.
                                            </p>
                                        </div>
                                    </div>

                                    {/* Feature 3 */}
                                    <div className="flex items-start">
                                        <div className="mr-4 text-orange-600 mt-1">
                                            <FaDollarSign className="w-6 h-6 sm:w-7 sm:h-7" />
                                        </div>
                                        <div>
                                            <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-1">
                                                Transparent Pricing
                                            </h3>
                                            <p className="text-gray-600 text-sm sm:text-base">
                                                No hidden fees - we provide clear, upfront pricing for all
                                                our services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right side image for mobile view */}
                        <div className="lg:hidden mt-10 relative w-full">
                            <img
                                src="/why_chose_us_img_2.webp"
                                alt="Air Comfort Experts"
                                className="w-full h-auto rounded-lg shadow-lg"
                            />
                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center bg-blue-900 rounded-full w-20 h-20 text-white ring-2 ring-orange-600">
                                <span className="text-xl font-bold">80%</span>
                                <span className="text-xs text-center">Success Rate</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call-to-action section */}
            <div
                className="relative bg-orange-600 h-[280px] sm:h-[300px] my-10 sm:my-16 px-4 sm:pl-16 pt-10 sm:pt-0"
                style={{
                    backgroundImage: `url("/HeroRight.svg")`,
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="container mx-auto h-full flex flex-col lg:flex-row items-center justify-between gap-8">
                    {/* Content */}
                    <div className="w-full lg:w-1/2 z-10 text-center sm:text-left">
                        <div className="flex justify-center sm:justify-start items-center gap-2 mb-3">
                            <Lottie className="w-6" animationData={Fan} />
                            <h1 className="text-white text-base sm:text-lg font-bold uppercase">
                                Free to contact us
                            </h1>
                        </div>
                        <p className="text-2xl sm:text-4xl text-white font-semibold leading-snug">
                        Book Your Services with Us <br />
                            <span>With Us!</span>
                        </p>
                        <div className="mt-5 sm:mt-6">
                            <button onClick={openModal} className="bg-white text-orange-600 uppercase text-sm px-5 sm:px-6 py-2 sm:py-3 rounded-md font-medium hover:bg-gray-100 transition">
                                Book Now <FaArrowRight className="inline-block ml-2" />
                            </button>
                        </div>
                    </div>

                    {/* Right image (desktop only) */}
                    <div className="hidden lg:block absolute right-0 top-0 h-full w-1/2">
                        <img
                            className="w-full h-full object-cover object-left"
                            src="/cta_img_1.webp"
                            alt="Premium Air Services"
                        />
                    </div>
                </div>
            </div>
            {showModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
                <div className="bg-white w-full max-w-3xl  rounded-lg relative overflow-y-auto max-h-[90vh]">
                  <button
                    onClick={closeModal}
                    className="absolute top-2 right-2 text-2xl text-orange-500 hover:text-red-500"
                  >
                    <HiX />
                  </button>
                  <GetInTouch showModal={showModal} />
                </div>
              </div>
            )}
        </div>
    );
};

export default WhyChooseUs;
